document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] #cmdk-input`);
  if (!inputSearch) return;

  if(inputSearch) window.dispatchEvent(new Event('scroll'));
  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });


  const searchButtons = document.querySelectorAll('.search-modal__button.header-actions__action');
  const resetButtons = document.querySelectorAll('[ref="resetButton"]');
  
  searchButtons.forEach((button) => {
    button.addEventListener('click', () => {
       window.dispatchEvent(new Event('scroll'));
    });
  });

  resetButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
      setTimeout(() => { 
    console.log(123)
        window.dispatchEvent(new Event('scroll'));
      },1000)
    });
  });
});
